/** Seeded hashes. All visual / ledger randomness goes through here — never time. */

export function hashU32(n: number): number {
  let x = n >>> 0;
  x = Math.imul(x ^ (x >>> 16), 0x7feb352d) >>> 0;
  x = Math.imul(x ^ (x >>> 15), 0x846ca68b) >>> 0;
  return (x ^ (x >>> 16)) >>> 0;
}

export function hash01(...parts: number[]): number {
  let h = 0x811c9dc5;
  for (let i = 0; i < parts.length; i += 1) {
    const x = parts[i];
    const bits = Number.isFinite(x) ? Math.floor(x * 1e6) : i + 1;
    h = Math.imul(h ^ (bits >>> 0), 0x01000193) >>> 0;
    h = hashU32(h ^ (i * 0x9e3779b9));
  }
  return h / 4294967296;
}

export function mulberry32(seed: number): () => number {
  let a = seed >>> 0;
  return () => {
    a = (a + 0x6d2b79f5) >>> 0;
    let t = Math.imul(a ^ (a >>> 15), 1 | a);
    t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) >>> 0;
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function brickSeed(col: number, course: number, wallSeed: number): number {
  return hashU32(
    Math.imul(col + 1, 0x27d4eb2d) ^ Math.imul(course + 3, 0x165667b1) ^ (wallSeed + 17),
  );
}
